<template>
  <div style="margin-bottom: 10px;">
    <div class="container-top" v-if="!embed">
      <div class="container d-flex align-items-center">
        <div class="flex-grow-1">
          <img class="img-fluid" src="./assets/images/logo_fispal_food.png" alt />
        </div>
        <div class="d-none d-lg-block">
          <h1 class="text-white agenda-title">Agenda 2020</h1>
          <!-- <a href="https://www.futurecom.com.br/pt/inscreva-se.html" target="_blank" class="btn btn-warning mb-2 text-uppercase">
            <i class="fas fa-ticket-alt"></i>
            <span v-if="$route.params.language === 'pt'">Adquirir ingresso</span>
            <span v-if="$route.params.language === 'en'">Buy ticket</span>
            <span v-if="$route.params.language === 'es'">Adquirir ingreso</span>
          </a>-->
          <div class="flex justify-center pb-3">
            <button
              @click="change('pt')"
              type="button"
              class="btn"
              :class="{'btn-light' :$route.params.language === 'pt', 'btn-dark' :$route.params.language != 'pt'}"
            >PT</button>
            <button
              @click="change('en')"
              type="button"
              class="btn"
              :class="{'btn-light' :$route.params.language === 'en', 'btn-dark' :$route.params.language != 'en'}"
            >EN</button>
            <!-- <button @click="change('es')" type="button" class="btn"
              :class="{'btn-light' :$route.params.language === 'es', 'btn-dark' :$route.params.language != 'es'}">
              ES
            </button>-->
          </div>
        </div>
      </div>
    </div>
    <v-nav v-if="!embed"></v-nav>
    <div class="top-spacer"></div>
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-sm d-flex justify-content-center mt-5">
          <div class="text-center">
            <h5 class="mb-2">{{ sponsor }}</h5>
            <img src="https://static.techevent.cloud/futurecom19/sponsors/linx.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VNav from "./components/layout/Nav.vue";
import VNavMobile from "./components/layout/NavMobile.vue";
export default {
  name: "app",
  data() {
    return {
      msg: ""
    };
  },
  components: {
    VNav,
    VNavMobile
  },
  computed: {
    sponsor() {
      switch (this.$route.params.language) {
        case "en":
          return "Silver Sponsor";
          break;
        case "es":
          return "Patrocinador Prata";
          break;
        default:
          return "Patrocinador Prata";
          break;
      }
    },
    embed() {
      if (this.$route.query.embed === "true") {
        return true;
      }
      return false;
    }
  },
  methods: {
    change(lang) {
      this.$router.push({ params: { language: lang } });
    }
  }
};
</script>

<style scoped>
.agenda-title {
  text-shadow: 1px 5px 4px #000;
}
.container-top {
  background: url("./assets/images/topo_fispalfood_2020.png") no-repeat center
    center #0d0f0e;
  /* background: #0d0f0e; */
}
.container-top .container {
  height: 180px;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.6s ease;
  transition-delay: 0.8s;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/App.vue